export enum LegalDocumentType {
	PersonalDataConsent = 'PersonalDataConsent',
	CompanyTermsConditions = 'CompanyTermsConditions',
}
